var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOther(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.16667V2.5H5.83333V5.83333H2.5V17.5H9.16667V14.1667H10.8333V17.5H17.5V9.16667H14.1667ZM5.83333 15.8333H4.16667V14.1667H5.83333V15.8333ZM5.83333 12.5H4.16667V10.8333H5.83333V12.5ZM5.83333 9.16667H4.16667V7.5H5.83333V9.16667ZM9.16667 12.5H7.5V10.8333H9.16667V12.5ZM9.16667 9.16667H7.5V7.5H9.16667V9.16667ZM9.16667 5.83333H7.5V4.16667H9.16667V5.83333ZM12.5 12.5H10.8333V10.8333H12.5V12.5ZM12.5 9.16667H10.8333V7.5H12.5V9.16667ZM12.5 5.83333H10.8333V4.16667H12.5V5.83333ZM15.8333 15.8333H14.1667V14.1667H15.8333V15.8333ZM15.8333 12.5H14.1667V10.8333H15.8333V12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOther);
export default __webpack_public_path__ + "static/media/ic_other.0a3d44aacfedc99f794631c62d65012f.svg";
export { ForwardRef as ReactComponent };